export default __webpack_public_path__ + "static/media/rotate.17ed4dd5.svg";